<template>
  <div class="device-content" v-loading="loading">
    <el-button
      type="primary"
      @click="openEditWin('create')"
      >{{$t('lampGroup.add_new')}}</el-button
    >
    <el-table :data="tableData" style="width: 100%;">
      <el-table-column prop="number" :label="$t('device.device_number')" align="center"></el-table-column>
      <el-table-column prop="name" :label="$t('device.device_name')" align="center"></el-table-column>
      <el-table-column :label="$t('device.single_Double')" prop="is_double" align="center">
        <template slot-scope="scope">
          {{ doubleType[scope.row.is_double] }}
        </template>
      </el-table-column>
      <el-table-column prop="brightness" :label="$t('device.light')" align="center"></el-table-column>
      <el-table-column prop="stg_name" :label="$t('device.strategy')" align="center"></el-table-column>
      <el-table-column :label="$t('device.online_status')" align="center">
        <template slot-scope="scope">
          <i :class="steColorArr[scope.row.ste]"></i>
          <span>{{ steList[scope.row.ste] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="edit" :label="$t('lampGroup.unbind')" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              class="el-icon-link pointer"
              @click="bindGroup(0, scope.row.lamp_id, groupId)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"   
    >
    </el-pagination>
    <!--新增关联路灯-->
    <el-dialog
      class="dialog600"
      :title="$t('lampGroup.association')"
      :visible.sync="editOne.dialogVisible"
      v-if="editOne.dialogVisible"
      append-to-body
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="140px"
      >
        <div class="user-info">
          <el-form-item :label="$t('lampGroup.select_lamp')">
            <el-select
              clearable
              filterable
              :placeholder="$t('lampGroup.select_lamp')"
              v-model="editOne.lamp_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in unBandLampList"
                :key="t.lamp_id"
                :label="t.number"
                :value="t.lamp_id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="editOne.dialogVisible = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="bindGroup(1, editOne.lamp_id, groupId)"

          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import lampsApi from "@/api/device/lamps"
import lampGroupApi from "@/api/device/lampGroup";
import commonJs from '@/utils/common'
export default {
  name: "deviceList",
  props: {
    groupId: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      doubleType: this.$t('device.doubleType'),
      steColorArr: ["valuegrey", "valuegreen"],
      steList: this.$t('device.steList'),
      lightStatus:  this.$t('device.lightStatus'),
      tableData: [],
      pageInfo: {
        sortBy: 'lamp_id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 20
      },
      filter: {
        lamp_group: ''
      },
      cnt_all: 0,
      unBandLampList: [],
      editOne: {
        lamp_id: '',
        number: '',
        dialogVisible: false
      }
    };
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
  methods: {
    getTableData(pageIndex) {
      // 获取该分组下的所有路灯
      this.filter.lamp_group = this.groupId
      this.loading = true;
      this.pageInfo.page = pageIndex;
      let filter = this.filter;
      filter = filter && commonJs.obj.removeNullKey(filter);
      if (filter && Object.keys(filter).length) {
        this.pageInfo.filter = JSON.stringify(filter);
      }
      lampsApi.lightList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.unBandLamps()
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    unBandLamps() {
      // 获取没有分组的路灯
      lampGroupApi.getUnassignedGroupLamps({
        page: 1,
        pageSize: 2000
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.unBandLampList = resData.list;
        }
      });
    },
    openEditWin() {
      this.editOne = {
        lamp_id: '',
        number: '',
        dialogVisible: true
      }
    },
    bindGroup(type, ids, lamp_group) {
      if(!ids){
        return this.$message.error(this.$t('lampGroup.select_lamp'));
      }      
      lampGroupApi.bindGroup({
        allocation: type,
        lamp_group: lamp_group,
        ids: ids
      }).then((res) => {
        if (res.data.code === 1000) {
          if(type){
            this.editOne.dialogVisible = false;
            this.$message.success(this.$t('lampGroup.bind_tip'));
          }else{
            this.$message.success(this.$t('lampGroup.unbind_tip'));
          }
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
  }
};
</script>
<style lang='less' scoped>
.device-content {
  width: 100%;
  padding-bottom: 20px;
}
</style>
